export enum PaymentSessionType {
	PAYMENT = 'payment',
	ONBOARDING = 'merchantonboarding',
	DEPOSITREPORT = 'DepositReport',
	PAYMENTREPORT = 'PaymentReport',
}
